﻿$(document).ready(function () {

    $('#tcSection').hide();
    $('#emailFormSection').hide()
    var numOfSlides = 3
    var formOpen = false
    var termsOpen = false
    var currentSlide = 1;
    hideSlide(2)
    hideSlide(3)
    toggleButtons()
    markDot()

    var countWords = function (string) {
        return string
            .replace(/(^\s*)|(\s*$)/gi, "")
            .replace(/\s+/gi, " ")
            .split(' ').length;
    };

    window.Parsley
        .addValidator('maxwords', {
            requirementType: 'integer',
            validateString: function (value, requirement) {
               
                return countWords(value) < requirement;
            },
            messages: {
                en: 'Max %s words allowed',
            }
        });
    function moveToElement(id, speed=800) {
        elementId = "#" + id;
        $("html, body").animate(
            {
                scrollTop: $(elementId).offset().top
            },
            speed
        );
    }

    function toggleForm() {
        if (formOpen) {
            $('#emailFormSection').fadeOut();
            formOpen = false;

        } else {
            $('#emailFormSection').fadeIn();
            formOpen = true;
            moveToElement("emailFormSection")
        }
    }

    $('#charityApply').on('click touchstart', function () {        
        toggleForm();  
    })

    // move this to separate file?
    function toggleTerms() {
        if (termsOpen) {
            $('#tcSection').fadeOut();
            termsOpen = false;

        } else {
            $('#tcSection').fadeIn();
            termsOpen = true;
            moveToElement("tcSection")
        }
    }
    $('#termsandconditions, #closeTerms').on('click touchstart', function () {
        toggleTerms()
        return false
    })
    
    function toggleButtons() {
        if (currentSlide == 1) {
            $('#charityNext').removeAttr('disabled')
            $('#charityPrev').prop('disabled', true)
            $('#charitySendForm').hide()

        } else if (currentSlide > 1 && currentSlide < numOfSlides) {
            $('#charityNext').removeAttr('disabled')
            $('#charityPrev').removeAttr('disabled')
            $('#charitySendForm').hide()

        } else {
            $('#charityNext').prop('disabled', true)
            $('#charityPrev').removeAttr('disabled')
            $('#charitySendForm').show()
        }
    }

    function markDot() {
      
            $('.dot').each(function (i, obj) {
                if (parseInt($(this).data("value")) == currentSlide) {
                    $(this).addClass('active')
                } else {
                    $(this).removeClass('active')
                }

            })
        
    }

    $('.dot').on('click touchstart', function () {

        var nextSlide = parseInt($(this).data("value"))

        if (nextSlide != currentSlide) {
            if (nextSlide > currentSlide) {
                if (formIsValid()) {
                    hideSlide(currentSlide)
                    showSlide(nextSlide)
                    currentSlide = nextSlide
                    markDot()
                    toggleButtons()
                }
            } else {
                hideSlide(currentSlide)
                showSlide(nextSlide)
                currentSlide = nextSlide
                markDot()
                toggleButtons()
            }        
        } 
    }) 
   
    function hideSlide(slideNum) {
        var slideId = '#slide' + String(slideNum)
        $(slideId).removeClass().css({ 'visibility': 'hidden', 'height': '0'})
      
    }
    function showSlide(slideNum) {
        var slideId = '#slide' + String(slideNum)
        $(slideId).addClass('col-lg-6').css({ 'visibility': 'visible', 'height': 'auto' })
    }
    function prevSlide() {     
        if (currentSlide > 1) {
            hideSlide(currentSlide)
            currentSlide -= 1
            showSlide(currentSlide)
            markDot()
        }
    }
    function nextSlide() {
        if (currentSlide < numOfSlides) {
            hideSlide(currentSlide)
            currentSlide += 1
            showSlide(currentSlide)
            markDot()
        }
    }

    function formIsValid() {
     
        var groupName = currentSlide == 1 ? "yourDetails" : currentSlide == 2 ? "charityDetails1" : "charityDetails2";
      
        var isValid = $('#emailform').parsley().isValid({ group: groupName })
        if (!isValid) {
            $('#emailform').parsley().validate({ group: groupName })
            return false
        } else if (isValid == null) {
            return false
        }  
        return true;
    }


    $('#charityNext').on('click touchstart', function () {

        if (currentSlide < 3 && formIsValid()) {           
            nextSlide();
            toggleButtons()
            
        }
    })

    $('#charityPrev').on('click touchstart', function () {

        if (currentSlide > 1) {
            prevSlide()
            toggleButtons()
        }
    })

    function formIsSubmitting(isSubmitting) {
        if (isSubmitting) {
            $('#charitySendForm').prop('disabled', true)
            $('#charitySendForm').prop('value', 'Sending...')
            $('#charityNext').prop('disabled', true)
            $('#charityPrev').prop('disabled', true)
        }
    }
    $('#emailform').on('submit', function (e) {
        if (typeof (grecaptcha) !== 'undefined') {
            var capres = grecaptcha.getResponse();
            //console.log("capres", capres);
            if (capres == '') {
                return false;
            }
        }

        if (!formIsValid()) {
            e.preventDefault()
        }
        else {
            formIsSubmitting(true)
        }
    })


})

window.submitCommunityFundForm = function (token) {
    var ajaxForm = $('#emailform');

    if (ajaxForm.parsley().validate()) {
        $.ajax({
            type: 'POST',
            url: '/api/sitecore/Form/SendEmailForm',
            data: ajaxForm.serialize(),
            success: function (result) {
                // Handle the successful server response
                $('#recaptchaError').hide();
                $('#registerError').hide();
                $('#emailform').hide();
                $('#registerThanks').show();
                console.log("onSubmit Ajax success!")
                //console.log(result);
            },
            error: function (xhr, textStatus, errorThrown) {
                $('#registerThanks').hide();
                if (xhr.status == 403) {
                    $('#recaptchaError').show();
                    grecaptcha.reset();
                } else {
                    $('#emailform').hide();
                    $('#registerError').show();
                }
                console.log(xhr)            
                console.log(errorThrown);                               
          }
        });
    } else {
        grecaptcha.reset();
    }
  
}